import { Document,Text,Page,StyleSheet,Image, View, Font } from '@react-pdf/renderer';
import LogoWhite from "../../assets/images/K2GLogoWhite.png";
import MIMWheel from "../../assets/images/MIMWheel.png";
import LIMWheel from "../../assets/images/LIMWheel.png";
import TopLogo from "../../assets/images/logo2.png";
import FullLogo from "../../assets/images/fullLogo.png";

Font.register({
    family: "Tahoma",
    src: "/fonts/Tahoma-Regular.ttf",
    fonts: [
      { src: "/fonts/Tahoma-Regular.ttf", fontWeight: "normal" },
      { src: "/fonts/TAHOMAB0.TTF", fontWeight: "bold" },
    ]
});

const styles = StyleSheet.create({
    page: {
        paddingTop: 30,
        paddingBottom: 90,
        paddingHorizontal: 50,
        fontFamily:"Tahoma"
    },
    sectionA: {
        display:"flex",
        flexDirection:"row",
        marginBottom: 20,
        alignItems: 'center',
    },
    sectionB: {
        width:"100%",
        marginBottom:20
    },
    sectionC: {
        display:"flex",
        flexDirection:"row",
        marginBottom: 20,
        alignItems: 'center',
        justifyContent:"center"
    },
    title: { fontSize: 18, marginBottom: 10 },
    mainTitle:{
        fontSize:30,
        fontWeight:600,
        textAlign:"center",
        color:"#0F5385",
        width: "100%",
        marginTop:40,
        marginLeft:20,
        flexShrink: 1
    },
    mainTitle_green:{
        fontSize:30,
        fontWeight:600,
        textAlign:"center",
        color:"#69AF45",
        width: "100%",
        marginLeft:20,
        flexShrink: 1
    },
    subTitle:{
        fontSize:30,
        fontWeight:700,
        textAlign:"center",
        color:"#0F5385",
        width: "100%",
        marginTop:40,
        marginLeft:20,
        flexShrink: 1
    },
    subTitle_green:{
        fontSize:25,
        fontWeight:400,
        textAlign:"center",
        color:"#69AF45",
        width: "100%",
        marginLeft:20,
        flexShrink: 1
    },
    userName:{
        fontSize:20,
        fontWeight:400,
        textAlign:"center",
        color:"#0F5385",
        width: "70%",
        marginLeft:20,
        marginBottom:40,
        flexShrink: 1
    },
    secondaryTitle:{
        fontSize:30,
        fontWeight:600,
        textAlign:"center",
        color:"#0F5385",
    },
    header:{
        fontSize:20,
        fontWeight:600,
        color:"#0F5385",
        marginTop:15,
        marginBottom:20
    },
    normalText:{
        fontSize:11.5,
        fontWeight:400,
        flexShrink: 1,
        marginTop:20,
        lineHeight:1.3
    },
    smallText:{
        fontSize:10,
        fontWeight:300,
        flexShrink: 1,
        marginTop:15,
        lineHeight:1.2
    },
    mainImage:{
        width:"20%"
    },
    chart: { width: "100%" },
    chartSummary: { width: "100%" },
    listContainer: {
        marginBottom: 10,
        marginTop:40
    },
    listItem: {
        flexDirection: 'row',
        marginBottom: 20, 
        alignItems: 'flex-start',
    },

    listBullet: {
        width: 15,
        fontSize: 10,
    },
    listItemText: {
        flex: 1,
        fontSize: 12,
    },
    bannerContainer: {
        paddingVertical: 30,
        width: '100%',
    },
    bannerTitle: {
        fontSize: 20,
        color: 'white',
        textAlign: 'center',
        fontWeight: 'bold',
    },
    bannerTitle2: {
        fontSize: 18,
        color: 'white',
        textAlign: 'center',
        fontWeight: 'bold',
    },
    bannerSubtitle: {
        fontSize: 20,
        color: 'white',
        textAlign: 'center',
        fontWeight: 400,
    },
    table: { 
        display: "flex", 
        width: "60%",
        flexDirection: "column",
        margin: "20 auto",
        borderWidth: 1,
        borderColor: '#000000',
    },
    tableRow: { 
        flexDirection: "row", 
        borderBottomWidth: 1, 
        borderColor: '#000000',
    },
    tableHeader: {
        backgroundColor: '#F0F0F0',
        fontWeight: 'bold',
        padding: 5,
        fontSize: 10,
    },
    tableCell: {
        padding: 5,
        fontSize: 10,
    },
    cellCol1: {
        width: '50%',
        borderRightWidth: 1,
        borderColor: '#000000',
    },
    cellCol2: {
        width: '50%',
    },
    pageNumbers: {
        position: 'absolute',
        bottom: 20,
        left: 0,
        right: 20,
        textAlign: 'right',
        fontSize:10
    },
    heroBanner: {
        width: "100%",
        height: 120,
        backgroundColor: "#0F5385", // azul de fondo
        flexDirection: "row",
        alignItems: "center",
        paddingHorizontal: 35,
    },
    heroImage: {
        width: 80,
        height: 80,
        marginRight: 20,
    },
    heroTextContainer: {
        flex: 1,
    },
    heroTitle: {
        fontSize: 24,
        fontWeight: "bold",
        color: "#FFFFFF",
        marginBottom: 6,
    },
    heroSubtitle: {
        fontSize: 16,
        fontWeight: 400,
        color: "#FFFFFF",
    },
    footerImage: {
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%",
        height: 60, 
    },
    footerImageBulb: {
        position: "absolute",
        bottom: 0,
        left: 20,
        width: "auto",
        height: 80, 
    },
    headerInfo: {
        marginTop: 30,          // separación del banner
        marginBottom: 30,
        alignItems: "flex-start" // que el texto quede alineado a la izquierda
    },
    headerName: {
        fontSize: 24,
        fontWeight: 600,
        color: "#0F5385",
        marginLeft:40
    },
    headerDate: {
        fontSize: 16,
        fontWeight: 400,
        color: "#69AF45",
        marginTop: 4,
        marginLeft:40
    },
    fullLogo:{
        width:"70%"
    },
    bannerTitleRow: {
        flexDirection: "row",
        alignItems: "flex-start", // alinea la parte alta de los textos
        justifyContent:"center"
    },
    bannerTitleMain: {
        fontSize: 24,
        fontWeight: "bold",
        color: "#FFFFFF",
    },
    bannerTitleSup: {
        fontSize: 14,
        fontWeight: "bold",
        color: "#FFFFFF",
        marginLeft: 0,
        marginTop: 4,
    },
    textRow: {
        flexDirection: "row",
        alignItems: "flex-start", // alinea la parte alta de los textos
    },
    textMain: {
        fontWeight: 600,
        color:"#0F5385",
    },
    textSup: {
        fontWeight: "bold",
        color:"#0F5385",
        marginLeft: 0,
    },
    header2:{
        fontSize:17,
        fontWeight:500,
        color:"#0F5385",
        marginTop:15,
        marginBottom:0
    },
});

const MyList = ({ items,title }) => {

    const cleanTitle = (text)=>{
        return text.replace('<sup>&reg;</sup>', '®').replace('<sup>®</sup>', '®');
    }

    return (
        // 1. Contenedor de la lista (simula <ul>)
        <View style={styles.listContainer}>
            <Text style={styles.header}>{title}</Text>
            {items.map((item, index) => (
            // 2. Elemento de la lista (simula <li>)
            <View key={index} style={styles.listItem}>
                {/* 3. Viñeta */}
                <Text style={styles.listBullet}>•</Text>
                {/* 4. Contenido */}
                <Text style={styles.listItemText}>{cleanTitle(item)}</Text>
            </View>
            ))}
        </View>
    )
};

const ColorBanner = ({ title, color }) => (
    <View style={[styles.bannerContainer, { backgroundColor: color }]}>
      {colorBannerTitleWithSup(title)}
    </View>
);

const titleWithSup = (text) => {
    const [before, after] = text.split("<sup>&reg;</sup>");
  
    return (
      <View style={styles.bannerTitleRow}>
        <Text style={styles.bannerTitleMain}>{before}</Text>
        <Text style={styles.bannerTitleSup}>®</Text>
        {after ? <Text style={styles.bannerTitleMain}>{after}</Text> : null}
      </View>
    );
};

const colorBannerTitleWithSup = (text, size = 20,justify = "flex-start",color = "white") => {
    // Si no trae el marcador, regresamos un <Text> normal
    if (!text.includes("<sup>&reg;</sup>")) {
      return <Text style={styles.bannerTitle}>{text}</Text>;
    }
  
    const [before, after] = text.split("<sup>&reg;</sup>");

    const supSize = Math.round(size * 0.55);      // 55% del tamaño principal
    const supOffset = Math.round(size * 0.12);    // subirlo un poco relativo al tamaño

    return (
        <View style={[styles.textRow,{justifyContent:justify,paddingLeft:"5px"}]}>
        {/* Texto principal */}
        <Text style={[styles.textMain, { fontSize: size, color:color }]}>
            {before}
        </Text>

        {/* Superíndice ® */}
        <Text
            style={[
            styles.textSup,
            { fontSize: supSize, marginTop: -supOffset, color:color},
            ]}
        >
            ®
        </Text>

        {after ? (
            <Text style={[styles.textMain, { fontSize: size, color:color }]}>{" "}{after}</Text>
        ) : null}
        </View>
    );
};

const MainBanner = ({ title,subtitle, color }) => (
    <View style={styles.heroBanner}>
        <Image src={LogoWhite} style={styles.mainImage}/>
        <View style={styles.heroTextContainer}>
            {titleWithSup(title)}
            <Text style={styles.bannerSubtitle}>{subtitle}</Text>
        </View>
    </View>
);

const textWithSup = (text, size = 20,justify = "flex-start") => {
    const [before, after] = text.split("<sup>&reg;</sup>");

    const supSize = Math.round(size * 0.55);      // 55% del tamaño principal
    const supOffset = Math.round(size * 0.12);    // subirlo un poco relativo al tamaño

    return (
        <View style={[styles.textRow,{justifyContent:justify}]}>
        {/* Texto principal */}
        <Text style={[styles.textMain, { fontSize: size }]}>
            {before}
        </Text>

        {/* Superíndice ® */}
        <Text
            style={[
            styles.textSup,
            { fontSize: supSize, marginTop: -supOffset },
            ]}
        >
            ®
        </Text>

        {after ? (
            <Text style={[styles.textMain, { fontSize: size }]}>{" "}{after}</Text>
        ) : null}
        </View>
    );
};

const DEFAULT_THRESHOLDS = {
    strength: { label: "STRENGTH", minScore: 90 },
    developing: { label: "DEVELOPING", minScore: 60 },
    opportunity: { label: "OPPORTUNITY" },
};

const resolveThresholds = (report) => {
    const t = report?.ratingThresholds;
    return {
        strength: {
            label: t?.strength?.label || DEFAULT_THRESHOLDS.strength.label,
            minScore: typeof t?.strength?.minScore === "number" ? t.strength.minScore : DEFAULT_THRESHOLDS.strength.minScore,
        },
        developing: {
            label: t?.developing?.label || DEFAULT_THRESHOLDS.developing.label,
            minScore: typeof t?.developing?.minScore === "number" ? t.developing.minScore : DEFAULT_THRESHOLDS.developing.minScore,
        },
        opportunity: {
            label: t?.opportunity?.label || DEFAULT_THRESHOLDS.opportunity.label,
        },
    };
};

const buildTableData = (thresholds) => {
    const t = thresholds || DEFAULT_THRESHOLDS;
    const developingMin = t.developing.minScore;
    const strengthMin = t.strength.minScore;
    const developingMax = strengthMin - 1;
    return [
        { score: `${strengthMin}% or higher`, rating: `A ${t.strength.label} area for you` },
        { score: `${developingMin}%-${developingMax}%`, rating: `A ${t.developing.label} area for you` },
        { score: `Less than ${developingMin}%`, rating: `An ${t.opportunity.label} area for you` },
    ];
};

const RatingTable = ({ thresholds }) => {
    const tableData = buildTableData(thresholds);
    return (
    // 1. Contenedor de la tabla
    <View style={styles.table}>
        
        {/* ENCABEZADO (TableHead) */}
        <View style={[styles.tableRow, styles.tableHeader]}>
            {/* Celda 1 (Score) */}
            <View style={[styles.cellCol1, { borderBottomWidth: 0 }]}>
                <Text style={styles.tableHeader}>Score {"\n"}(% of positive responses)</Text>
            </View>
            {/* Celda 2 (Rating) */}
            <View style={styles.cellCol2}>
                <Text style={styles.tableHeader}>Rating</Text>
            </View>
        </View>

        {/* CUERPO (TableBody) */}
        {tableData.map((item, index) => (
            <View key={index} style={styles.tableRow}>
                {/* Celda 1 (Score) */}
                <View style={styles.cellCol1}>
                    <Text style={styles.tableCell}>{item.score}</Text>
                </View>
                {/* Celda 2 (Rating) */}
                <View style={styles.cellCol2}>
                    <Text style={styles.tableCell}>{item.rating}</Text>
                </View>
            </View>
        ))}
    </View>
    );
};

const SCORE_LABELS = {
    0: "",
    1: "Not Confident",
    2: "Somewhat Confident",
    3: "Confident",
    4: "Very Confident",
};

const PDFBarChart = ({ data, color }) => {
    const maxScore = 4;
    const barWidth = 260;

    return (
        <View style={{ marginTop: 8, marginBottom: 4 }}>
            {/* Header row with score labels */}
            <View style={{ flexDirection: "row", marginBottom: 4 }}>
                <View style={{ width: 220 }} />
                {[1, 2, 3, 4].map((val) => (
                    <Text key={val} style={{ width: barWidth / maxScore, fontSize: 7, color: "#555", textAlign: "center" }}>
                        {SCORE_LABELS[val]}
                    </Text>
                ))}
            </View>
            {/* Rows */}
            {data.map((item, idx) => (
                <View key={idx} wrap={false} style={{ flexDirection: "row", alignItems: "center", marginBottom: 10 }}>
                    {/* Question label */}
                    <Text style={{ width: 220, fontSize: 8, color: "#333", paddingRight: 6 }}>
                        {item.question}
                    </Text>
                    {/* Bar background + filled bar */}
                    <View style={{ width: barWidth, height: 14, backgroundColor: "#E8E8E8", position: "relative" }}>
                        <View style={{
                            position: "absolute",
                            left: 0,
                            top: 0,
                            height: 14,
                            width: item.resp > 0 ? (item.resp / maxScore) * barWidth : 0,
                            backgroundColor: color || "#1976d2",
                        }} />
                        {/* Grid lines */}
                        {[1, 2, 3].map((val) => (
                            <View key={val} style={{
                                position: "absolute",
                                left: (val / maxScore) * barWidth,
                                top: 0,
                                width: 0.5,
                                height: 14,
                                backgroundColor: "#CCCCCC",
                            }} />
                        ))}
                    </View>
                </View>
            ))}
        </View>
    );
};

const AssessmentPDF = ({chartData,blocks,nameA,slug,report,summaryIntroImg,sectionsIntroImg,info,name,blockNotes={},dateCompleted,extraQ})=>{

    const thresholds = resolveThresholds(report);
    const programName = slug === "mim_self_assessment" ? "Managers in Motion" : "Leaders in Motion";
    const coverSubtitle = report?.coverSubtitle || "Self-Assessment Report";
    const summaryBannerTitle = report?.summaryBannerTitle || `${programName}<sup>&reg;</sup> Self-Assessment Summary`;
    const summaryMethodology = report?.summaryMethodology || `Your self-assessment report reflects your confidence level on four dimensions.  Each dimension had 10 related questions.  To calculate your percentage score in each dimension, we counted the number of questions you answered, "Very Confident" or "Confident," and used these two answers to represent "Positive Responses". We then calculated the percentage of your total answers that were "Positive Responses".`;
    const summaryCategorization = report?.summaryCategorization || "For developmental purposes, we categorized your score into three different levels to help you focus your development priorities.";

    const cleanTitle = (text)=>{
        return text.replace('<sup>&reg;</sup>', '®').replace('<sup>®</sup>', '®');
    }

    const textWithReg = (text, style = styles.normalText) => {
        if (!text) return null;
        const cleaned = text.replace(/<sup>&reg;<\/sup>/g, '®').replace(/<sup>®<\/sup>/g, '®');
        if (!cleaned.includes('®')) return <Text style={style}>{cleaned}</Text>;
        const parts = cleaned.split('®');
        return (
            <Text style={style}>
                {parts.map((part, i) => (
                    i < parts.length - 1
                        ? <Text key={i}>{part}<Text style={{ fontSize: 7, verticalAlign: 'super' }}>®</Text></Text>
                        : <Text key={i}>{part}</Text>
                ))}
            </Text>
        );
    }

    const findInfoText = (blockId)=>{
        const i = info.find((b)=>b.block === blockId) 
        return i?.text || "";
    }

    return(
        <Document>
            <Page>
                {
                    slug === "mim_self_assessment" &&
                    <MainBanner title={"Managers in Motion<sup>&reg;</sup>"} subtitle={coverSubtitle} color={"#105385"}/>
                }
                {
                    slug === "lim_self_assessment" &&
                    <MainBanner title={"Leaders in Motion<sup>&reg;</sup>"} subtitle={coverSubtitle} color={"#105385"}/>
                }
                 <View style={styles.headerInfo}>
                    <Text style={styles.headerName}>{name}</Text>
                    <Text style={styles.headerDate}>{dateCompleted}</Text>
                </View>
                <Image src={slug === "mim_self_assessment"?MIMWheel:LIMWheel}/>
                {/* Page number display */}
                <Text
                    style={styles.pageNumbers}
                    render={({ pageNumber }) => (
                    `${pageNumber}`
                    )}
                    fixed // Ensures the page number is rendered consistently on each page
                />
                {/* FOOTER CON IMAGEN */}
                {/* <Image src={FooterTrees} style={styles.footerImage}/> */}
                {/* TOP CON IMAGEN */}
                <Image src={TopLogo} style={styles.footerImageBulb}/>
            </Page>
            <Page style={styles.page}>
                <View style={styles.sectionB}>
                    {
                        slug === "mim_self_assessment" && 
                        <>
                            {textWithSup("Managers in Motion<sup>&reg;</sup>",30,"center")}
                            <Text style={styles.subTitle_green}>Self-Assessment</Text>
                        </>
                    }
                    {
                        slug === "lim_self_assessment" && 
                        <>
                            {textWithSup("Leaders in Motion<sup>&reg;</sup>",30,"center")}
                            <Text style={styles.subTitle_green}>Self-Assessment</Text>
                        </>
                    }
                    {textWithReg(report.welcome)}
                    <MyList items={report.howToUse} title={"How to Use This Feedback"}/>
                </View>
                <Text
                    style={styles.pageNumbers}
                    render={({ pageNumber }) => (
                    `${pageNumber}`
                    )}
                    fixed // Ensures the page number is rendered consistently on each page
                />
                {/* FOOTER CON IMAGEN */}
                {/* <Image src={FooterTrees} style={styles.footerImage}/> */}
                {/* TOP CON IMAGEN */}
                <Image src={TopLogo} style={styles.footerImageBulb}/>
            </Page>
            <Page style={styles.page}>
                {(slug === "mim_self_assessment" || slug === "lim_self_assessment") &&
                    <ColorBanner title={summaryBannerTitle} color={"#0F5385"}/>
                }
                <Text style={styles.normalText}>{summaryMethodology}</Text>
                <Text style={styles.normalText}>{summaryCategorization}</Text>
                <RatingTable thresholds={thresholds}/>
                {/* {summaryIntroImg && (
                    <>
                        <Text style={styles.header}>Summary</Text>
                        <Image style={styles.chartSummary} src={summaryIntroImg} />
                    </>
                )} */}
                {sectionsIntroImg && (
                    <>
                        <Text style={styles.header}>Summary Scores for Each Category</Text>
                        <Image style={styles.chartSummary} src={sectionsIntroImg} />
                    </>
                )}
                <Text
                    style={styles.pageNumbers}
                    render={({ pageNumber }) => (
                    `${pageNumber}`
                    )}
                    fixed // Ensures the page number is rendered consistently on each page
                />
                {/* FOOTER CON IMAGEN */}
                {/* <Image src={FooterTrees} style={styles.footerImage}/> */}
                {/* TOP CON IMAGEN */}
                <Image src={TopLogo} style={styles.footerImageBulb}/>
            </Page>
            {blocks.map((block) => {
                const DEFAULT_ANSWERS = ["notConfident", "somewhat", "confident", "very"];
                const rawNote = (blockNotes?.[block._id] ?? "").trim();
                const note = DEFAULT_ANSWERS.includes(rawNote) ? "" : rawNote;
                const blockData = chartData?.[block._id];
                return (
                    <Page key={block._id} style={styles.page} wrap>
                        <ColorBanner title={block.name} color={block.color}/>
                        <Text style={[styles.normalText,{marginBottom:5}]}>{findInfoText(block._id)}</Text>
                        {Array.isArray(blockData) && blockData.length > 0 ? (
                            <PDFBarChart data={blockData} color={block.color} />
                        ) : (
                            <Text>Graph not available for this section.</Text>
                        )}
                        <Text style={[styles.normalText,{fontWeight:600}]}>What stands out as a priority focus area in this dimension? Where might you want to focus?</Text>
                        {note && (
                            <Text style={[styles.smallText, { marginTop: 10 }]}>
                            {note}
                            </Text>
                        )}
                        <Text
                        style={styles.pageNumbers}
                        render={({ pageNumber }) => (
                        `${pageNumber}`
                        )}
                        fixed
                        />
                        <Image src={TopLogo} style={styles.footerImageBulb} fixed/>
                    </Page>
                )
            }
            )}
            <Page style={styles.page}>
                <View style={styles.sectionC}>
                    <Image src={FullLogo} style={styles.fullLogo}/>
                </View>
                <Text style={styles.header2}>Focus Areas for Development</Text>
                <Text style={[styles.normalText,{marginLeft:"5px",marginTop:"5px"}]}>1. Review your assessment results.</Text>
                <Text style={[styles.normalText,{marginLeft:"5px",marginTop:"5px"}]}>2. Examine the scores for each dimension and question.</Text>
                <Text style={[styles.normalText,{marginLeft:"5px",marginTop:"5px"}]}>3. Use the guidance below to identify next steps for your development.</Text>
                <Text style={[styles.normalText,{marginLeft:"5px",marginTop:"5px",marginBottom:"10px"}]}>4. Set personal Action Commitments.</Text>
                <Text style={styles.header2}>Strength (Scores of 90%+):</Text>
                <Text style={[styles.normalText,{marginTop:"5px"}]}>Dedicate yourself to a deeper understanding of the models and concepts in this area. Strive to become a true expert in all facets to drive consistent performance and improvement. What Action Commitments can you make to reinforce your strengths?</Text>
                <Text style={styles.header2}>Developing (Scores of 60%–89%):</Text>
                <Text style={[styles.normalText,{marginTop:"5px"}]}>You have opportunities for growth in these areas of competency. What Action Commitments can you make to build skills in these areas? Further education and regular practice will help solidify these skills and develop expertise.</Text>
                <Text style={styles.header2}>Opportunity (Less than 60%):</Text>
                <Text style={[styles.normalText,{marginTop:"5px"}]}>These areas present the biggest growth opportunities. Focus on understanding, reviewing, and applying the concepts. What Action Commitments can you make to mitigate the risks or consequences of these areas of development? Consider participating in individual workshops, online learning, or programs to enhance your skills.</Text>
                <Text style={[styles.header2,{marginTop:"20px"}]}>Based on your feedback in all areas, identify the top priority 2 or 3 areas you will focus on for development:</Text>
                <Text style={[styles.normalText,{marginTop:"20px"}]}>{extraQ}</Text>
                {/* Page number display */}
                <Text
                    style={styles.pageNumbers}
                    render={({ pageNumber }) => (
                    `${pageNumber}`
                    )}
                    fixed // Ensures the page number is rendered consistently on each page
                />
                {/* FOOTER CON IMAGEN */}
                {/* <Image src={FooterTrees} style={styles.footerImage}/> */}
                {/* TOP CON IMAGEN */}
                <Image src={TopLogo} style={styles.footerImageBulb}/>
            </Page>
        </Document>
    )
}

export default AssessmentPDF